import Layout from '../../Layout/Layout';

import { useSelector, useDispatch } from 'react-redux';
import { useDataTableContext } from '../../Contexts/DataTableContext';
import { toggleDialog } from '../../../redux/Slices/Global/globalSlice';

import "../css/apps.css";
import { useMemo } from 'react';
import { IoNewspaperOutline } from 'react-icons/io5';
import ClockDataTable from './ClockDataTable';
import ClockDialog from './ClockDialog';
import { setIsEditingWeather } from '../../../redux/Slices/Apps/appsSlice';
import { useTranslation } from 'react-i18next';
import FeatureLocked from '../../SharedComponents/FeatureLocked';

function ClockIndex() {
    const { t } = useTranslation();
    const openDialog = useSelector((state) => state.global.openDialog);
    const dispatch = useDispatch()

    const { getDataTable } = useDataTableContext();

    const subNavbarContent = useMemo(() => {
        return (
            <div className='flex justify-end w-100'>
                <button className="btn btn-primary mx-1" disabled={getDataTable.isLoading}
                    onClick={() => {
                        dispatch(setIsEditingWeather(false))
                        dispatch(toggleDialog("ClockDialog"))
                    }} > {t('clock.add_new_clock')} </button>
            </div>)
    }, [getDataTable.isLoading]);

    const subNavbarProps = useMemo(() => {
        return {
            icon: <i className="fas fa-clock text-secondary fs-2"></i> || " ",
        };
    }, []);

    if (getDataTable.error?.response?.status === 402) {
        return (
            <Layout>
                <FeatureLocked feature="clock" message={getDataTable.error.response.data?.message} />
            </Layout>
        );
    }

    return (
        <Layout subNavbarProps={subNavbarProps} subNavbarContent={subNavbarContent}>
            <div className="card">

                <div className=" d-flex flex-column  m-4">
                    <ClockDataTable />
                </div>
            </div>
            {openDialog.ClockDialog ? <ClockDialog /> : <></>}
        </Layout >
    )
}

export default ClockIndex